"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByNullsLast = exports.sortByNullsFirst = exports.orderByNullsLast = exports.orderByNullsFirst = void 0;
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var isNullish = function (value) { return value === null || typeof value === 'undefined'; };
var getOrderBy = function (nulls) {
    return function (_input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!_input || args.length === 0) {
            return _input;
        }
        var input = __spreadArray([], _input, true);
        var _a = (function () {
            var _orderByProperties = [];
            var _orderByDirections = [];
            args.forEach(function (_arg) {
                var _a = (function () {
                    if (_arg.startsWith('-')) {
                        return [_arg.slice(1), 'desc'];
                    }
                    return [_arg, 'asc'];
                })(), argname = _a[0], direction = _a[1];
                // first, push nullsfirst or nullslast for the current property
                _orderByProperties.push(function (e) { return isNullish(e[argname]); });
                _orderByDirections.push(nulls === 'NULLS_FIRST' ? 'desc' : 'asc');
                // now do the actual sorting based on value as a tie breaker.
                _orderByProperties.push(argname);
                _orderByDirections.push(direction);
            });
            return [_orderByProperties, _orderByDirections];
        })(), orderByProperties = _a[0], orderByDirections = _a[1];
        return (0, orderBy_1.default)(input, orderByProperties, orderByDirections);
    };
};
exports.orderByNullsFirst = getOrderBy('NULLS_FIRST');
exports.orderByNullsLast = getOrderBy('NULLS_LAST');
var getSortBy = function (nulls) {
    return function (_input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!_input || args.length === 0) {
            return _input;
        }
        // Shallow copy the input to prevent mutating the original array
        var input = __spreadArray([], _input, true);
        return input.sort(function (a, b) {
            for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
                var arg = args_1[_i];
                var direction = 'asc';
                var propertyName = arg;
                // Handle descending
                if (arg.startsWith('-')) {
                    direction = 'desc';
                    propertyName = arg.slice(1);
                }
                var aValue = a[propertyName];
                var bValue = b[propertyName];
                // Handle nullish values
                if (isNullish(aValue) && !isNullish(bValue)) {
                    return nulls === 'NULLS_FIRST' ? -1 : 1;
                }
                if (!isNullish(aValue) && isNullish(bValue)) {
                    return nulls === 'NULLS_FIRST' ? 1 : -1;
                }
                // When both are non-nullish, compare them
                if (!isNullish(aValue) && !isNullish(bValue)) {
                    // Detect if values are numeric
                    var areBothNumeric = typeof aValue === 'number' && typeof bValue === 'number';
                    if (areBothNumeric) {
                        // Numeric comparison
                        return direction === 'asc' ? aValue - bValue : bValue - aValue;
                    }
                    else {
                        var comparisonResult = "".concat(aValue).localeCompare("".concat(bValue), 'en-US', {
                            sensitivity: 'base',
                        });
                        if (comparisonResult !== 0) {
                            return direction === 'asc' ? comparisonResult : -comparisonResult;
                        }
                    }
                }
            }
            // If all comparisons are equal, maintain original order (stable sort)
            return 0;
        });
    };
};
exports.sortByNullsFirst = getSortBy('NULLS_FIRST');
exports.sortByNullsLast = getSortBy('NULLS_LAST');
//# sourceMappingURL=index.js.map